import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Button, FormControl, FormLabel, Input, Stack, InputGroup, InputRightElement, Center, Box, useBreakpointValue, useToast, Toast } from '@chakra-ui/react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';

const apiUrl = process.env.REACT_APP_API_URL;

const Logout = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('accessToken');
        navigate('/login');
    };

    const [isLogoutLoading, setIsLogoutLoading] = useState(false);

    const handleLogoutWithLoading = () => {
        setIsLogoutLoading(true);
        setTimeout(() => { // Simulate a delay for logout
            handleLogout();
            setIsLogoutLoading(false);
        }, 1000); // Adjust the delay as needed
    };

    return (
        <Button
            variant='solid'
            colorScheme='red'
            onClick={handleLogoutWithLoading}
            isLoading={isLogoutLoading}
            loadingText="Logging out"
        >
            Logout
        </Button>
    );
}

const RefreshAccessToken = () => {
    const refreshToken = localStorage.getItem('refreshToken');
    return axios.post(`${apiUrl}/refresh-token`, { refreshToken })
        .then(response => {
            localStorage.setItem('accessToken', response.data.accessToken);
            localStorage.setItem('refreshToken', response.data.refreshToken);
            return response.data.accessToken;
        });
};

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const formPadding = useBreakpointValue({ base: '5', md: '8' });
    const [show, setShow] = React.useState(false)
    const [isLoginLoading, setIsLoginLoading] = useState(false);
    const [isSignUpLoading, setIsSignUpLoading] = useState(false);
    const handleClick = () => setShow(!show)

    const navigate = useNavigate();
    const toast = useToast();

    const handleUsernameChange = (event) => {
        setUsername(event.target.value);
    };

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    };

    const handleSignUp = () => {
        setIsSignUpLoading(true);
        axios.post(`${apiUrl}/signup`, { username, password })
            .then(response => {
                localStorage.setItem('accessToken', response.data.accessToken);
                localStorage.setItem('refreshToken', response.data.refreshToken);
                navigate('/habits');
                setIsSignUpLoading(false);
            })
            .catch(error => {
                console.error(error);
                setIsSignUpLoading(false);
            });
    };

    const handleLogin = () => {
        if (!username || !password) {
            let message = '';
            if (!username && !password) {
                message = 'Username and password cannot be empty';
            } else if (!username) {
                message = 'Username cannot be empty';
            } else if (!password) {
                message = 'Password cannot be empty';
            }
            if (message) {
                toast({
                    title: 'Error',
                    description: message,
                    status: 'error',
                    duration: 5000,
                    isClosable: true,
                });
                return;
            }
            return;
        }

        setIsLoginLoading(true);
        axios.post(`${apiUrl}/login`, { username, password })
            .then(response => {
                localStorage.setItem('accessToken', response.data.accessToken);
                localStorage.setItem('refreshToken', response.data.refreshToken);
                navigate('/habits');
                console.log('navigated to habits')
                setIsLoginLoading(false);
            })
            .catch(error => {
                console.error(error);
                let message = 'An error occurred while logging in.';
                if (error.response.status === 401) {
                    message = 'Invalid username or password';
                }
                toast({
                    title: 'Error',
                    description: message,
                    status: 'error',
                    duration: 5000,
                    isClosable: true,
                });
                setIsLoginLoading(false);
            });
    };

    return (
        <Center h="100vh">
            <Box
                w={{ base: '90%', md: '400px' }} // Responsive width
                p={formPadding} // Responsive padding
                border='1px' // Border width
                borderColor='teal'
                rounded="lg" // Optionally rounds the corners
            >
                <Stack spacing={4}>
                    <FormControl id="username" isRequired>
                        <FormLabel>Username</FormLabel>
                        <Input variant='outline' placeholder='Enter Username' onChange={handleUsernameChange} type="text" />
                    </FormControl>
                    <FormControl id="password" isRequired>
                        <FormLabel>Password</FormLabel>
                        <InputGroup size='md'>
                            <Input
                                pr='4.5rem'
                                onChange={handlePasswordChange}
                                type={show ? 'text' : 'password'}
                                placeholder='Enter password'
                            />
                            <InputRightElement width='4.5rem'>
                                <Button h='1.75rem' size='sm' onClick={handleClick}>
                                    {show ? <ViewOffIcon /> : <ViewIcon />}
                                </Button>
                            </InputRightElement>
                        </InputGroup>
                    </FormControl>
                    <Button variant='solid' colorScheme='teal' onClick={handleLogin} isLoading={isLoginLoading}>Login</Button>
                    <Button variane='solid' colorScheme='teal' onClick={handleSignUp} isLoading={isSignUpLoading}>Sign Up</Button>
                </Stack>
            </Box>
        </Center>
    );
};

export { Login, Logout, RefreshAccessToken };
